











import Helper from "@/components/Helper.vue"

import {Component, Vue} from "vue-property-decorator";

@Component({
    components:{
        Helper
    }
})
export default class SoupLetter extends Vue {


}
